import buildFinalHeroImageURL from 'commons/buildHeroImageURL';

const contructHeroImageForNonConfigurableProduct = (name, id, count = 1) =>
  buildFinalHeroImageURL(name, id, '', '', count, true);

export default contructHeroImageForNonConfigurableProduct;
